module.exports = __webpack_public_path__ + "img/flag.f8fa7847.png";